import React from "react";
import FooterStyle from "../assets/stylesheets/Footer.module.css";
import { Instagram, Youtube, Facebook } from "lucide-react";
import SignupForm from "./SignupForm";
import { Logo } from "../assets/logo/Logo";

// TikTok icon component
const TikTok = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path
      d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
      fill="currentColor"
    />
  </svg>
);

// import Logger from "../utils/logger";

// const log = Logger.create('Footer');

export default function Footer({ categoryStyle = false }) {
  return (
    <footer
      className={`${FooterStyle["footer-wrapper"]} ${
        categoryStyle ? FooterStyle["footer-category"] : ""
      }`}
    >
      <div className={FooterStyle["container"]}>
        <div className={FooterStyle["footer-top"]}>
          <div className={FooterStyle["footer-column"]}>
            <ul className={FooterStyle["footer-logo-container"]}>
              <a href="/" className={FooterStyle["footer-logo-link"]}>
                <Logo
                  className={FooterStyle["footer-logo"]}
                  aria-label="Farmciti Logo"
                />
              </a>
            </ul>
          </div>
          <div className={FooterStyle["footer-column"]}>
            <h4 className={FooterStyle["footer-heading"]}>Farmciti</h4>
            <ul className={FooterStyle["footer-list"]}>
              <li>
                <p>
                  Farmciti is a digital platform that connects people with
                  authentic farm experiences, from pick-your-own to seasonal
                  events.
                </p>
              </li>
            </ul>
          </div>

          <div className={FooterStyle["footer-column"]}>
            <SignupForm />
          </div>
        </div>
        <hr />
        <div className={FooterStyle["footer-bottom"]}>
          <div className={FooterStyle["footer-bottom-left"]}>
            <span>© Farmciti 2025. All rights reserved</span>
            <a href="#" className={FooterStyle["footer-link"]}>
              Terms
            </a>
          </div>
          <div className={FooterStyle["footer-bottom-right"]}>
            <span>Stay with us</span>

            <div className={FooterStyle["social-links"]}>
              <a
                href="https://www.instagram.com/farmciti.ca"
                className={FooterStyle["social-link"]}
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.tiktok.com/@farmciti_canada"
                className={FooterStyle["social-link"]}
                aria-label="TikTok"
                target="_blank"
                rel="noopener noreferrer"
              >
                <TikTok size={20} />
              </a>
              <a
                href="https://www.youtube.com/@FarmCitiCanada"
                className={FooterStyle["social-link"]}
                aria-label="YouTube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Youtube size={20} />
              </a>
              <a
                href="https://www.facebook.com/people/FarmCiti/61573789681716/"
                className={FooterStyle["social-link"]}
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
